import React, { useState, useEffect } from 'react';
import { Card, Row, Col } from 'antd';
import Cookies from 'js-cookie';

/**
 * About component that displays my personal information and profile picture.
 * 
 * @component
 * @returns {JSX.Element} The About page with profile information
 */
const About = () => {
  const [language, setLanguage] = useState(Cookies.get('language') || 'de');

  // Contains shown text on website
  const about_me = {
    de: "Hi, ich bin Vinzenz und arbeite seit 2024 als Softwareentwickler bei PubPharm. Mein Schwerpunkt liegt auf der Automatisierung von Datenverarbeitungsprozessen mit Apache Airflow. Zusätzlich bin ich stark in das Refactoring bestehenden Codes und die Verbesserung der Testabdeckung involviert. In meiner Freizeit arbeite ich an zwei kleinen persönlichen Programmierprojekten." ,
    en: "Hi, I'm Vinzenz and I have been working as a software developer at PubPharm since 2024. My focus is on automating data processing workflows with Apache Airflow. Additionally, I am heavily involved in refactoring existing code and improving test coverage. In my free time, I work on two small personal coding projects."

  };

  // handles changes on the selected language
  useEffect(() => {
    const handleCookieChange = () => {
      const newLanguage = Cookies.get('language') || 'de';
      setLanguage(newLanguage);
    };

    const interval = setInterval(handleCookieChange, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ background: 'linear-gradient(to right,rgb(175, 82, 175),rgb(39, 39, 131))', minHeight: '100vh', overflowX: 'hidden', }}>
      <Row gutter={[16, 16]} style={{ padding: '20px' }}>
        <Col xs={24} sm={12} md={8} style={{ margin: '0 auto' }}>
          <Card
            title={<div style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>About Me</div>}
            bordered={true}
            style={{
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              backgroundColor: 'white',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              {/* Left side: Text */}
              <div style={{ flex: '2', paddingRight: '20px' }}>
                <p>{about_me[language]}</p>
              </div>

              {/* Right side: Image */}
              <div style={{ flex: '1', textAlign: 'center'  }}>
                <img
                  src="./profil.jpg"
                  alt="About Me"
                  style={{
                    maxWidth: '100%',
                    borderRadius: '0px',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default About;